import { format, parseISO, isBefore, startOfDay } from 'date-fns'
import { fr } from 'date-fns/locale'

export const formatDate = (date, formatString = 'dd/MM/yyyy') => {
  if (!date) return ''

  const dateObj = typeof date === 'string' ? parseISO(date) : date
  return format(dateObj, formatString, { locale: fr })
}

export const formatLongDate = (date) => {
  if (!date) return ''

  const dateObj = typeof date === 'string' ? parseISO(date) : date

  let formatted = format(dateObj, 'd MMMM yyyy', { locale: fr })

  // specific handling for "1er"
  if (formatted.startsWith('1 ')) {
    formatted = formatted.replace('1 ', '1er ')
  }

  return formatted
}

export const formatMonthYear = (date) => {
  if (!date) return ''
  const dateObj = typeof date === 'string' ? parseISO(date) : date
  return format(dateObj, 'MMMM yyyy', { locale: fr })
}

export const addOneDay = (date) => {
  const next = new Date(date)
  next.setDate(next.getDate() + 1)
  return next
}

export const displayedDates = (opening_date, closing_date, multiline = false, useLongFormat = false) => {
  const formatter = useLongFormat ? formatLongDate : formatDate

  if (opening_date && closing_date) {
    const formattedOpening = formatter(opening_date)
    const formattedClosing = formatter(closing_date)

    if (formattedOpening === formattedClosing) {
      return <span>le {formattedOpening}</span>
    }

    if (multiline) {
      return (
        <span>
          Du {formattedOpening}
          <br />
          au {formattedClosing}
        </span>
      )
    }

    return (
      <span>
        Du {formattedOpening} au {formattedClosing}
      </span>
    )
  } else if (opening_date && !closing_date) {
    return (
      <span>
        {isBefore(opening_date, startOfDay(new Date())) ? 'Depuis le' : 'A partir du'} {formatter(opening_date)}
      </span>
    )
  }

  return null
}
